import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledContainer = styled(Stack)({
  height: "100%",
  width: "100%",
  overflow: "auto",
  position: "relative",
  // padding: "15px 15px 15px 0px",
  "::-webkit-scrollbar": {
    display: "none",
  },
});